import React, { Component } from "react";
import { connect } from "react-redux";
import { HotKeys } from "react-hotkeys";
import keyMap from "../utils/keyMap";
import { toggleConfigurationMode } from "../redux/actions/configurationActions";

class GlobalShortcutsContainer extends Component {
  componentDidMount() {
    this.container.focus();
  }

  handlers = {
    settings: () => {
      this.props.toggleConfigurationMode();
    }
  };

  render() {
    return (
      <HotKeys
        keyMap={keyMap}
        handlers={this.handlers}
        innerRef={c => (this.container = c)}
      >
        {this.props.children}
      </HotKeys>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    toggleConfigurationMode: () => dispatch(toggleConfigurationMode())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalShortcutsContainer);



// WEBPACK FOOTER //
// ./src/containers/GlobalShortcutContainer.js